let envConfig = {
  apiUrl : "https://cms-gcp.classplusapp.com/student/api/v2",
  wlUrl : "https://api.classplusapp.com",
  apiUrlTutor : "https://cms-gcp.classplusapp.com/tutor/api/v2",
  apiUrlStudent : "https://cms-gcp.classplusapp.com/student/api/v2",
  baseUrlDeployment : "https://online-test.classplusapp.com",
  studentUrlDeployment : "https://student-cms.classplusapp.com"
}

if(process.env.REACT_APP_BUILD_ENV === "preprod"){
  envConfig.apiUrl = "https://cms-preprod.classplusapp.com/student/api/v2";
  envConfig.wlUrl = "https://apip-preprod.classplusapp.com";
  envConfig.apiUrlTutor = "https://cms-preprod.classplusapp.com/tutor/api/v2";
  envConfig.apiUrlStudent = "https://cms-preprod.classplusapp.com/student/api/v2";
  envConfig.baseUrlDeployment = "https://online-test-preprod.classplus.co";
  envConfig.studentUrlDeployment = "https://stud-web-cms-preprod.classplusapp.com";
} else if(process.env.REACT_APP_BUILD_ENV === "staging"){
  envConfig.apiUrl = "https://cms-staging.classplusapp.com/student/api/v2";
  envConfig.wlUrl = "https://apip-staging.classplusapp.com";
  envConfig.apiUrlTutor = "https://cms-staging.classplusapp.com/tutor/api/v2";
  envConfig.apiUrlStudent = "https://cms-staging.classplusapp.com/student/api/v2";
  envConfig.baseUrlDeployment = "https://online-test-staging.classplus.co";
  envConfig.studentUrlDeployment = "https://stud-web-cms-staging.classplusapp.com";
} else if(process.env.REACT_APP_BUILD_ENV === "prod"){
  envConfig.apiUrl = "https://cms-gcp.classplusapp.com/student/api/v2";
  envConfig.wlUrl = "https://api.classplusapp.com";
  envConfig.apiUrlTutor = "https://cms-gcp.classplusapp.com/tutor/api/v2";
  envConfig.apiUrlStudent = "https://cms-gcp.classplusapp.com/student/api/v2";
  envConfig.baseUrlDeployment = "https://online-test.classplusapp.com";
  envConfig.studentUrlDeployment = "https://student-cms.classplusapp.com";
}
else if(process.env.REACT_APP_BUILD_ENV === "qa"){
  envConfig.apiUrl = "https://cms-qa.classplusapp.com/student/api/v2";
  envConfig.wlUrl = "https://apip-qa.classplusapp.com";
  envConfig.apiUrlTutor = "https://cms-qa.classplusapp.com/tutor/api/v2";
  envConfig.apiUrlStudent = "https://cms-qa.classplusapp.com/student/api/v2";
  envConfig.baseUrlDeployment = "https://online-test-qa.classplus.co";
  envConfig.studentUrlDeployment = "https://stud-web-cms-qa.classplusapp.com";
}

export default {
  API_URL: envConfig?.apiUrl,
  WL_URL: envConfig?.wlUrl,
  API_URL_TUTOR: envConfig?.apiUrlTutor,
  API_URL_STUDENT: envConfig?.apiUrlStudent,
  DEPLOY_URL: envConfig?.baseUrlDeployment,
  STUDENT_URL: envConfig?.studentUrlDeployment,
};

export const internalWebView = (payload, testType) => {
  console.log(
    testType === "TB_TEST"
      ? `UTIL_WEBVIEW,${payload.url}`
      : !payload.isUrl
      ? `UTIL_WEBVIEW,${envConfig?.baseUrlDeployment}${payload.url}`
      : `UTIL_TEST,${payload.url}`,
    "internalWebview",
    payload
  );
  let response = {};
  if(testType === "TB_TEST"){
    response.screen = "UTIL_WEBVIEW";
    response.paramOne = `${payload.url}`;
  } else if(!payload.isUrl){
    response.screen = "UTIL_WEBVIEW";
    response.paramOne = `${envConfig?.baseUrlDeployment}${payload.url}`;
  } else {
    response.screen = "UTIL_TEST";
    response.paramOne = `${payload.url}`;
  }
  console.log('JSON.stringify(response)',JSON.stringify(response))

  if (window && window.mobile && window.mobile.onDeeplinkExecutedV2) {
    window.mobile.onDeeplinkExecutedV2(JSON.stringify(response));
  }
  if (
    window &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.onDeeplinkExecutedV2
  ) {
    window.webkit.messageHandlers.onDeeplinkExecutedV2.postMessage(
      JSON.stringify(response)
    );
  }
};
